<template>
  <header>
    <nav>
      <div class="logo-bar">
        <a href="http://www.mtv.com/" target="_blank">
          <span class="mtv-logo"></span>
          <p>siesta key</p>
        </a>
      </div>

      <div class="social-bar">
        <a href="http://www.facebook.com/siestakeymtv" target="_blank">
          <span data-graphics="N" class="icon"></span>
          <span class="screen-reader-text">facebook</span>
        </a>
        <a href="https://twitter.com/SiestaKey" target="_blank">
          <span data-graphics="O" class="icon"></span>
          <span class="screen-reader-text">twitter</span>
        </a>
        <a href="https://www.instagram.com/siestakey" target="_blank">
          <span data-graphics="d" class="icon"></span>
          <span class="screen-reader-text">instagram</span>
        </a>
      </div>
    </nav>
  </header>
</template>

<script>
import Vue from "vue";
export default Vue.extend({});
</script>
<style lang="scss" scoped>
header {
  background-color: #232323;
  padding: rems(5px);
}

nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 85%;
  margin: 0 auto;
}

nav a {
  display: inline-block;
  text-decoration: none;
  &:hover {
    color: $nav-link-hover-color;
  }
}

.logo-bar p {
  font-family: "AkzidenzGrotesk", sans-serif;
  font-weight: 700;
  color: #fff;
  display: inline-block;
  padding-left: rems(30px);
  font-size: rems(25px);
  margin: rems(6px) 0;
  vertical-align: middle;
  @media screen and (max-width: 500px) {
    display: none;
  }
}

.logo-bar .mtv-logo {
  display: inline-block;
  vertical-align: middle;
}

.logo-bar .mtv-logo:before {
  font-size: rems(36px);
}

.social-bar {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.social-bar a {
  font-family: "mtv";
  font-size: rems(32px);
  vertical-align: middle;
  margin: 0 rems(6px);
}
.social-bar a span {
  display: inline-block;
  color: #fff;
  vertical-align: middle;
}
.social-bar a span::before {
  font-family: "mtv";
  font-size: rems(32px);
  vertical-align: top;
}
.social-bar a [data-graphics="N"]:before {
  content: "\e900";
}
.social-bar a [data-graphics="O"]:before {
  content: "\e905";
}
.social-bar a [data-graphics="d"]:before {
  content: "\e902";
}

.screen_reader_text,
.screen-reader-text {
  left: -9999px;
  position: absolute;
  top: -9999px;
}
</style>
